export const wrapMessageStreamer = (response: Promise<Response>) => {
  return response
}
